<template>
  <footer class="main-footer">
    <div class="container">
      <div class="footer-grid">
        <div class="footer-brand">
          <img src="@/assets/images/arkayl_logo_white.png" :alt="$t('logoAlt')" class="footer-logo">
          <p class="footer-description">{{ $t('footerDescription') }}</p>
        </div>

         <div class="footer-links">
          <h4>{{ $t('menuServices') }}</h4>
          <ul>
            <li><router-link to="/services">{{ $t('serviceListItemTitle_1') }}</router-link></li>
            <li><router-link to="/services">{{ $t('serviceListItemTitle_2') }}</router-link></li>
            <li><router-link to="/services">{{ $t('serviceListItemTitle_3') }}</router-link></li>
            <li><router-link to="/services">{{ $t('serviceListItemTitle_4') }}</router-link></li>
            <li><router-link to="/services">{{ $t('serviceListItemTitle_5') }}</router-link></li>
            <li><router-link to="/services">{{ $t('serviceListItemTitle_6') }}</router-link></li>
          </ul>
        </div>

        <div class="footer-links">
          <h4>{{ $t('menuAbout') }}</h4>
          <ul>
            <li><router-link to="/">{{ $t('menuHome') }}</router-link></li>
            <li><router-link to="/about-us">{{ $t('menuAbout') }}</router-link></li>
            <li><router-link to="/projects">{{ $t('menuProjects') }}</router-link></li>
            <li><router-link to="/contact">{{ $t('menuContact') }}</router-link></li>
          </ul>
        </div>

        <div class="footer-contact">
          <h4>{{ $t('menuContact') }}</h4>
          <a class="email-link" href="mailto:office@arkayl.org">office@arkayl.org</a>
          <p>{{ $t('footerLocation') }}</p>
          <div class="social-icons">
            </div>
        </div>
      </div>
    </div>
     <div class="footer-bottom">
        <p>{{ $t('footerCopyright', { year: currentYear }) }}</p>
      </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.main-footer {
  background-color: #062D45;
  color: #ffffff;
  padding: 60px 0 0;
}

.footer-grid {
  display: grid;
  grid-template-columns: 3fr 2fr 2fr 2fr;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-logo {
  width: 250px;
}

.email-link {
  color: #cbd5e0;
  transition: all .3s ease;
}

.email-link:hover {
  color: #63b3ed;
}

.footer-description {
  color: #cbd5e0;
  line-height: 1.6;
  font-size: 14px;
  max-width: 300px;
}

.footer-links h4,
.footer-contact h4 {
  color: #ffffff;
  margin-bottom: 20px;
  font-size: 18px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 12px;
}

.footer-links a {
  color: #cbd5e0;
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 15px;
}

.footer-links a:hover {
  color: #63b3ed;
}

.footer-contact p {
  color: #cbd5e0;
  font-size: 15px;
  margin-bottom: 10px;
}

.footer-bottom {
  background: #032439;
  padding: 10px;
  margin: 0;
  text-align: center;
}

.footer-bottom p {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
}

@media (max-width: 1024px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 600px) {
  .footer-grid {
    grid-template-columns: 1fr;
    text-align: center;
    gap: 0;
  }
  .footer-logo {
    margin: 0 auto 20px auto;
  }
  .footer-description {
    margin: 0 auto;
  }
}
</style>
